module.exports = __webpack_public_path__ + "static/media/explore-thumbnail.7c18958f.png";